import React from 'react';
import { Box, Button, Typography } from '@heycater/design-system';
import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Container from 'system/components/Container';

function Hero({ title, subtitle }) {
  const { t } = useTranslation('static_pages');
  const router = useRouter();

  return (
    <>
      <MainWrapper py={5}>
        <HeroContent>
          <Container size="sm">
            {title ? (
              <Typography variant="h2" component="h1">
                {title}
              </Typography>
            ) : (
              <Typography variant="h2" component="h1">
                <Trans
                  t={t}
                  i18nKey="baseHero.title"
                  components={[<span key="span" />]}
                />
              </Typography>
            )}
            <Typography variant="subtitle2" color="textSecondary" mt={2}>
              {subtitle ? subtitle : t('baseHero.subtitle')}
            </Typography>
            <StyledButton
              rounded
              size="lg"
              onClick={() => router.push('/start')}
              id="seo-berlin-qual-survey"
            >
              {t('baseHero.cta')}
            </StyledButton>
          </Container>
        </HeroContent>
      </MainWrapper>
    </>
  );
}

const MainWrapper = styled(Box)`
  background: ${(props) => props.theme.colors.heroGradient};
`;

const HeroContent = styled.header`
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const StyledButton = styled(Button)`
  margin: ${(props) => props.theme.spacing(7, 0, 3)};
  padding-left: ${(props) => props.theme.spacing(8)}px;
  padding-right: ${(props) => props.theme.spacing(8)}px;
`;

export default Hero;
